<template>
  <div class="dialog content-detail">
    <div class="dialog__container">
      <div class="dialog__title">
        {{ currentReferenceListItem.title }}
      </div>
      <div class="dialog__body">
        <div
          class="video-container"
          @mouseenter="showControls"
          @mouseleave="hideControls"
        >
          <video
            ref="video"
            playsinline
            :src="`/theme/rbFront/img/w/mediaArtSolution/video/${currentReferenceListItem.video}`"
            class="video"
            @loadedmetadata="handleLoadedMetadata"
            @ended="handleVideoEnd"
            @timeupdate="updateProgress"
          />
          <div
            class="controls"
            :class="{ 'controls--visible': isControlsVisible }"
          >
            <button
              class="controls__button"
              :class="{ 'controls__button--playing': isPlaying }"
              :style="playPauseButtonStyle"
              @click="togglePlayPause"
            />
            <svg
              class="progress-ring"
            >
              <circle
                class="progress-ring__circle progress-ring__circle--bg"
                stroke="rgba(255, 255, 255, 0.3)"
                stroke-width="8"
                fill="transparent"
                r="36"
                cx="40"
                cy="40"
              />
              <circle
                class="progress-ring__circle progress-ring__circle--progress"
                stroke="#EA1917"
                stroke-width="8"
                fill="transparent"
                r="36"
                cx="40"
                cy="40"
                :style="progressStyle"
              />
            </svg>
            <div class="controls__text">
              {{ remainingTime }}
            </div>
          </div>
        </div>
        
        <div class="content-meta">
          <div class="content-meta__row">
            <div class="content-meta__label">
              Artist
            </div>
            <div class="content-meta__value">
              {{ currentReferenceListItem.artist }}
            </div>
          </div>
          <div class="content-meta__row">
            <div class="content-meta__label">
              Runtime
            </div>
            <div class="content-meta__value">
              {{ currentReferenceListItem.runtime }}
            </div>
          </div>
          <div class="content-meta__row">
            <div class="content-meta__label">
              Resolution
            </div>
            <div class="content-meta__value">
              {{ currentReferenceListItem.resolution }}
            </div>
          </div>
        </div>

        <div class="annotation">
          {{ currentReferenceListItem.description }}
        </div>

        <!-- Visible only ArtPlayer or BitGlim partner -->
        <div
          v-if="currentReferenceFilterId === 5 || currentReferenceFilterId === 6"
          class="disclimer"
        >
          Service provided by LG SuperSign Cloud
        </div>
      </div>
      <div class="dialog__footer content-detail__footer">
        <button
          class="lma-button lma-button--outline-red lma-button--red content-detail__button"
          type="button"
          @click="handleClickPreviewExperience"
        >
          Preview Experiences
        </button>
        <a
          href="/support/inquiry"
          class="lma-button lma-button--cta content-detail__button"
          role="button"
          target="_blank"
        >
          Contact Us
        </a>
      </div>
      <button
        type="button"
        class="dialog__close"
        @click="handeClickDetailClose"
      >
        Close
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    currentReferenceListItem: {
      type: Object,
      required: true,
    },
    currentReferenceFilterId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      isPlaying: false,
      progress: 0,
      playImageUrl: 'path/to/your-play-image.png',
      pauseImageUrl: 'path/to/your-pause-image.png',
      duration: 0,
      remainingTime: '0:00',
      totalDuration: '0:00',
      isControlsVisible: false,
      isEnded: false,
    };
  },
  computed: {
    progressStyle() {
      const circumference = 2 * Math.PI * 36;
      let progress = this.progress;
      // 비디오가 종료되었을 때 progress를 100%로 설정≠
      if (this.isEnded) {
        progress = 100;
      }
      const offset = circumference - (progress / 100) * circumference;
      return {
        strokeDasharray: `${circumference} ${circumference}`,
        strokeDashoffset: offset,
      };
    },
    playPauseButtonStyle() {
      return {
        // backgroundImage: `url(${this.isPlaying ? this.pauseImageUrl : this.playImageUrl})`
        backgroundColor: '#000'
      }
    },
  },
  mounted() {
    // this.$nextTick(() => {
    //   this.isPlaying = true
    //   this.$refs.video.play().catch(error => {
    //     console.error('Auto-play was prevented:', error);
    //     this.isPlaying = false
    //   });
    // });
  },
  methods: {
    handeClickDetailClose() {
      this.$emit('close');
    },
    handleClickPreviewExperience() {
      this.$emit('preview-experience');
    },
    handleLoadedMetadata() {
      // this.$refs.video.addEventListener('loadeddata', () => {
      //   console.log('loadeddata event fired')
      //   this.setVideoMoveFirstFrame()
      //   this.setDuration()
      // }, { once: true })
      this.setVideoMoveFirstFrame()
      this.setDuration()
    },
    setVideoMoveFirstFrame() {
      this.$refs.video.play()
      setTimeout(() => {
        this.$refs.video.pause()
        this.$refs.video.currentTime = 0.1
      }, 1)
    },
    setDuration() {
      this.duration = this.$refs.video.duration;
      const minutes = Math.floor(this.duration / 60);
      const seconds = Math.floor(this.duration % 60);
      this.totalDuration = `${minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
      this.remainingTime = this.totalDuration
    },
    updateProgress() {
      const currentTime = this.$refs.video.currentTime;
      const remainingTime = this.duration - currentTime;
      const minutes = Math.floor(remainingTime / 60);
      const seconds = Math.floor(remainingTime % 60);
      // progress 계산 정확도 개선
      this.progress = (currentTime / this.duration) * 100;
      // 비디오가 거의 끝나갈 때 (예: 99.5% 이상) isEnded를 true로 설정
      if (this.progress > 99.5) {
        this.isEnded = true;
      } else {
        this.isEnded = false;
      }
      this.remainingTime = `${minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
    },
    handleVideoEnd() {
      this.isPlaying = false;
      this.isEnded = true;
      this.progress = 100;
      this.remainingTime = this.totalDuration
    },
    togglePlayPause() {
      if (this.$refs.video.paused) {
        this.$refs.video.play();
        this.isPlaying = true;
        this.isEnded = false;
      } else {
        this.$refs.video.pause();
        this.isPlaying = false;
      }
    },
    showControls() {
      this.isControlsVisible = true;
    },
    hideControls() {
      this.isControlsVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.content-meta {
  display: flex;
  gap: 10px;
  padding: 0 35px;
  background-color: #F5F5F5;
  height: 54px;
  align-items: center;
  justify-content: space-between;
  border-radius: 16px;
  box-sizing: border-box;
  &__row {
    display: flex;
    justify-content: space-between;
    gap: 24px;
  }
  &__label {
    font-family: 'LG EI Text';
    font-size: 16px;
    font-weight: 600;
    text-transform: uppercase;
  }
  &__value {
    font-family: 'LG EI Text';
    font-weight: 300;
    font-size: 16px;
    color: #666;
    text-transform: uppercase;
  }
  @media screen and (max-width: 1080px) {
    flex-direction: column;
    height: auto;
    align-items: stretch;
    gap: 4px;
    padding: 11px 16px;
    &__label {
      font-size: 14px;
    }
    &__value {
      font-weight: 400;
      font-size: 14px;
    }
  }
}

.annotation {
  font-size: 16px;
  font-weight: 400;
  line-height: 20.8px;
  padding: 0 8px;
  @media screen and (max-width: 1080px) {
    font-size: 14px;
    line-height: 16.8px;
  }
}

.disclimer {
  font-size: 14px;
  font-weight: 400;
  line-height: 18.2px;
  color: #999;
  padding: 0 8px;
  @media screen and (max-width: 1080px) {
    font-size: 12px;
    line-height: 14.4px;
  }
}

.video-container {
  position: relative;
  width: 100%;
  padding-bottom: 48.09%; /* 16:9 비율 (9 / 16 = 0.5625) */
  height: 0;
  overflow: hidden;
  border-radius: 32px;
}
.video {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transform: translate(-50%, -50%);
}

.controls {
  opacity: 0;
  transition: opacity 0.3s;

  &--visible {
    opacity: 1;
    pointer-events: auto;
  }

  &__button {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    background-color: rgba(0, 0, 0, 0.5);
    border: none;
    cursor: pointer;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;
    padding: 0;

    &::before {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-40%, -50%);
      width: 0;
      height: 0;
      border-top: 12px solid transparent;
      border-bottom: 12px solid transparent;
      border-left: 20px solid white;
      z-index: 2;
    }

    &--playing::before {
      transform: translate(-50%, -50%);
      border: none;
      width: 20px;
      height: 20px;
      background-color: white;
    }
  }

  &__text {
    margin-top: 10px;
    font-family: 'LG EI Text', sans-serif;
    font-weight: 600;
    font-size: 16px;
    color: #fff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, calc(-50% + 54px));
    z-index: 2;
  }
}

.progress-ring {
  width: 80px;
  height: 80px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: rotate(-90deg) translate(50%, -50%);
  z-index: 1;
}

.progress-ring__circle {
  transition: stroke-dashoffset 0.3s linear;
}
/* 비디오 종료 시 transition 제거 */
.progress-ring__circle--progress[style*="stroke-dashoffset: 0"] {
  transition: none;
}

@media screen and (max-width: 1080px) {
  .video-container {
    border-radius: 16px;
    padding-bottom: 48.71794872%;;
  }
  // .progress-ring {
  //   width: 64px;
  //   height: 64px;
  // }
  // .controls {
  //   &__button {
  //     width: 48px;
  //     height: 48px;
  //   }
  // }
}

.content-detail {
  &__footer {
    justify-content: center;
    gap: 8px;
  }
  @media screen and (max-width: 1080px) {
    &__button {
      width: auto;
    }
  }
}
</style>